import EventEmitter from 'bare-events'

window.eventsChannel = new EventEmitter()
window.laytheme = new EventEmitter()
